import classNames from 'classnames'
import { Lock } from 'lucide-react'
import type { CalendarLockMarkProps } from './calendar-lock-mark.interface'
import classes from './calendar-lock-mark.module.scss'

export function CalendarLockMark({ className }: CalendarLockMarkProps) {
  return (
    <span className={classNames(classes.lockMark, className)} data-testid="calendar-lock-mark">
      <Lock className={classes.icon} aria-hidden="true" />
    </span>
  )
}
